import React, { useEffect, useState, useMemo } from "react";
import { CustomButton } from '../../../components/customButton/CustomButton';
import { useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { InfoControl } from './InfoControl';
import { ContratosPaciente } from './ContratosPaciente';
import { DireccionContent } from "./DireccionContent";
import { AptoInput } from "./AptoInput";
import { Profesionales } from "../../RIValidation/components/Profesionales";
import { RegistroDemoraInput } from "./RegistroDemoraInput";
import { CambioProgramaInput } from "../../RIAsignacion/components/CambioProgramaInput";
import { useGetActions } from "../hooks/useGetActions";

export const RIValidationDetalleContent = ({ setChildrenAction }) => {
    const location = useLocation();
    const stateData = location.state;
    const { notificationData, tipoNotificacion, idDelegacion, idTipoModulo } = stateData;
    const [notification, setNotification] = useState(notificationData || {});
    const [apto, setApto] = useState(false);
    const [contratosIds, setContratosIds] = useState([]);

    const handleChange = (name, value) => {
        setNotification(prevDatos => ({
            ...prevDatos,
            [name]: value
        }));
    }

    const {
        handleClickAsignar,
        handleClickValidar,
        handleClickModificarRI,
        handleClickRegistrarDemora,
        handleClickCambiarPrograma,
        loading: buttonActionLoading
    } = useGetActions({ handleChange, notification, location });

    useEffect(() => {
        if (!notification) return setChildrenAction(null);

        setChildrenAction(() => (
            (notification.estadoValidacion !== 'Validado' && <div className='top-buttons'>
                {(notification.estadoCoordinador === 'Pendiente') && <>
                    <div className='margin-right'>
                        <CambioProgramaInput
                            disabled={notification?.hasMultiplePrograms}
                            idEvaluacion={notification?.idEvaluacion}
                            loadingOthersButtons={buttonActionLoading}
                            handleClickAceptar={() => handleClickCambiarPrograma()}
                        />
                    </div>
                    <div className='margin-right'>
                        <RegistroDemoraInput
                            idEvaluacion={notification?.idEvaluacion}
                            otherButtonsLoading={buttonActionLoading}
                            handleClickAceptar={(demora) => handleClickRegistrarDemora(demora)}
                        />
                    </div>
                </>}
                {(notification.estadoRI !== 'Aprobado' && <div className='margin-right'>
                    <Profesionales
                        idDelegacion={idDelegacion}
                        idTipoModulo={idTipoModulo}
                        variant="outlined"
                        name="Reasignar"
                        handleRowClick={() => handleClickAsignar()}
                        loading={buttonActionLoading}
                        notification={notification}
                    />
                </div>
                )}
                {((notification.estadoRI === 'Aprobado' && ['Pendiente', 'Demorado', 'Correccion'].includes(notification.estadoCoordinador)) && <CustomButton
                    isLoading={buttonActionLoading}
                    className='margin-right'
                    variant="outlined"
                    onClick={() => handleClickModificarRI()}
                >
                    Modificar
                </CustomButton>
                )}
                <div className='margin-right'>
                    <AptoInput
                        idEvaluacion={notification?.idEvaluacion}
                        handleClickAceptar={(rechazo) => handleClickValidar(rechazo)}
                        loadingValidar={buttonActionLoading}
                        isReject={true}
                    />
                </div>
                {
                    <div className='margin-right'>
                        <AptoInput
                            idEvaluacion={notification?.idEvaluacion}
                            loadingValidar={buttonActionLoading}
                            handleClickAceptar={(rechazo) => handleClickValidar(rechazo)}
                            apto={apto}
                            fromRI={true}
                        />
                    </div>
                }
            </div>)
        ))
    }, [notification, buttonActionLoading, apto]);

    return <>

        <InfoControl
            notification={notification}
            tipoNotificacion={tipoNotificacion}
        />
        <DireccionContent
            notification={notification}
            setApto={setApto}
        />
        <ContratosPaciente
            idPaciente={notification?.hC}
            setContratosIds={setContratosIds}
        />
    </>
}